export const RESPONSE_ERRORS = {
  500: 'Что-то пошло не так',
  400: 'Ошибка формы',
}
